// Ortak TL para formatı — "80 TL" / "80,50 TL" (₺ sembolü YOK, sonek "TL").
// Tam sayılar ondalıksız, kesirliler 2 haneli gösterilir.
export function formatTL(amount) {
    const n = Number(amount);
    if (amount == null || Number.isNaN(n)) return '0 TL';
    const hasFraction = n % 1 !== 0;
    const s = n.toLocaleString('tr-TR', {
        minimumFractionDigits: hasFraction ? 2 : 0,
        maximumFractionDigits: 2,
    });
    return `${s} TL`;
}

// İki tutar arasındaki fark verilen KURUŞ toleransı içinde mi?
//
// Kayan noktalı karşılaştırma (Math.abs(a - b) > 0.05) sunucunun KABUL ettiği tutarı arayüzde
// reddediyordu: Math.abs(971.15 - 971.20) = 0.05000000000006821 > 0.05. Sunucu tarafı decimal
// ile çalışıyor (FleetInvoiceAmountRule ±0,05 TL), bu yüzden karşılaştırma kuruşa çevrilip
// TAM SAYI üzerinden yapılır — iki taraf birebir aynı sınırı uygular.
export function isAmountWithinTolerance(a, b, toleranceKurus = 5) {
    const diffKurus = Math.round(Math.abs(Number(a || 0) - Number(b || 0)) * 100);
    return diffKurus <= toleranceKurus;
}

// Dönemde faturalanacak tutar oluşmuş mu? Zaman-bazlı kurye gideri paket gelirini aştığında
// hakediş net tutarı ≤ 0 olur; o dönem için fatura KESİLEMEZ (sunucu kuralıyla aynı sınır).
export function hasInvoiceableAmount(amount) {
    return Number(amount ?? 0) > 0;
}
